import React, { useState, useCallback, Suspense } from "react";
import Accordion from "react-bootstrap/esm/Accordion";

// ✅ Lazy load only what you need
const CompactForm = React.lazy(() => import("./PaperTradingForm"));
const CompactFormEdit = React.lazy(() => import("./PaperTradingFormEdit"));
const OrganizationTable = React.lazy(() => import("./OrganizationTable"));

function OrganizationTrades() {
  const [contractCreated, setContractCreated] = useState(0);
  const [copiedData, setCopiedData] = useState<any>(null);
  const [isEditMode, setEditMode] = useState<boolean>(false);
  const [editedData, setEditedData] = useState<any>(null);
  const [showCreateForm, setShowCreateForm] = useState(false);

  // ✅ Stable references
  const handleSetCopiedData = useCallback((data: any) => setCopiedData(data), []);
  const handleSetEditMode = useCallback((mode: boolean) => setEditMode(mode), []);
  const handleSetEditedData = useCallback((data: any) => setEditedData(data), []);
  const handleCloseForm = () => {
    setCopiedData(null);
  };
  return (
    <div className="page-body">
      <div className="table-ad">
        <Accordion defaultActiveKey="0" className="table-ad__addInputs">
          <Accordion.Item eventKey="0">
            <Accordion.Header className="accordion_button">
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  width: "100%",
                }}
              >
                <span>Organization Table</span>

                {/* Toggle */}
                <label
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    cursor: "pointer",
                    fontSize: "13px",
                    fontWeight: 500,
                    marginRight: "40px",
                  }}
                  onClick={(e) => e.stopPropagation()}
                >
                  <span>{showCreateForm ? "Cancel form" : "Create Trade"}</span>
                  <input
                    type="checkbox"
                    checked={showCreateForm}
                    onChange={() => setShowCreateForm((prev) => !prev)}
                    style={{ display: "none" }}
                  />
                  <span
                    style={{
                      width: "38px",
                      height: "20px",
                      backgroundColor: showCreateForm ? "#28a745" : "#ccc",
                      borderRadius: "20px",
                      position: "relative",
                      transition: "0.2s",
                    }}
                  >
                    <span
                      style={{
                        position: "absolute",
                        top: "2px",
                        left: showCreateForm ? "20px" : "2px",
                        width: "16px",
                        height: "16px",
                        backgroundColor: "#fff",
                        borderRadius: "50%",
                        transition: "0.2s",
                      }}
                    />
                  </span>
                </label>
              </div>
            </Accordion.Header>
            <Accordion.Body>
              <Suspense fallback={<div>Loading form…</div>}>
                {(showCreateForm || copiedData || isEditMode) && (
                  isEditMode ? (
                    <CompactFormEdit
                      contractCreated={contractCreated}
                      setContractCreated={setContractCreated}
                      setEditMode={handleSetEditMode}
                      isEditMode={isEditMode}
                      editedData={editedData}
                    />
                  ) : (
                    <CompactForm
                      contractCreated={contractCreated}
                      setContractCreated={setContractCreated}
                      copiedData={copiedData}
                      onClose={handleCloseForm}
                    />
                  )
                )}
              </Suspense>
              <Suspense fallback={<div>Loading table…</div>}>
                <OrganizationTable
                  contractCreated={contractCreated}
                  setCopiedData={handleSetCopiedData}
                  setEditMode={handleSetEditMode}
                  setEditedData={handleSetEditedData}
                  setShowCreateForm={setShowCreateForm}
                  showCreateForm={showCreateForm}
                />
              </Suspense>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </div>
    </div>
  );
}

export default React.memo(OrganizationTrades);
